import { render } from "./Obavijest.vue?vue&type=template&id=0b1e7258"
import script from "./Obavijest.vue?vue&type=script&lang=js"
export * from "./Obavijest.vue?vue&type=script&lang=js"

import "./Obavijest.vue?vue&type=style&index=0&id=0b1e7258&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__